import { atom } from "recoil";

const displayAtom = atom({
    key: 'display',
    default: {height: 0, width: 0}
})

export default displayAtom